// extracted by mini-css-extract-plugin
export default {"suggestion":"SearchSuggestion_suggestion__ciYjM","dark":"SearchSuggestion_dark__q4bbF","symbol":"SearchSuggestion_symbol__QHEwb","name":"SearchSuggestion_name__LIj0k"};